import Axioscall from "./Axois";

//intent history api
export const getIntentHistoryList = () => {
  return Axioscall.get("/service/getMyHistory");
};
//login getOtp

export const getOtp = (mobile, token) => {
  let url = `/auth/otp?mob=${mobile}&token=`;
  if (token) {
    url += token;
  }

  return Axioscall.get(url);
};

//login submitOtp

export const submitOtp = (logindata) => {
  return Axioscall.post("/auth/otp", logindata);
};

//login with credentials

export const submitCredential = (userData) => {
  return Axioscall.post("/auth/signIn", userData);
};

// details
export const getOrderDetails = () => {
  return Axioscall.get("/service/intentDetails");
};
//update acceptstatus
export const getAceeptResponse = (intent_id, requestStatus) => {
  return Axioscall.put("/service/updateStatus", {
    intent_id: intent_id,
    status: requestStatus,
  });
};

//update rejectstatus
export const getRejectResponse = (intent_id, requestStatus) => {
  return Axioscall.put("/service/updateStatus", {
    intent_id: intent_id,
    status: requestStatus,
  });
};

export const validateToken = (token) => {
  return Axioscall.get(`/service/vaidateToken/${token}`);
};

//user logout
export const userLogout = () => {
  return Axioscall.get("/auth/logout");
};

//changePassword
export const changePassword = (oldPassword, newPassword, confirmPassword) => {
  return Axioscall.post("/auth/resetPassword", {
    Current_Password: oldPassword,
    New_Password: newPassword,
    Confrim_Password: confirmPassword,
  });
};

//transporter send link
export const submitMobileLink = (driverLinkDetails) => {
  return Axioscall.post("/service/sendDriverLink", driverLinkDetails);
};

//get otp send link
export const getMobileLink = () => {
  return Axioscall.get("/driver/otp");
};

//post otp
export const postMobileOTP = (otp) => {
  return Axioscall.post("/driver/otp", otp);
};

//driver intent Details
export const getIntentDetails = (token) => {

  return Axioscall.get("/driver/intentDetails");

};

//gate IN/OUT
export const gateInOut = (gateInOutData) => {
  return Axioscall.post("/driver/gateInOut", gateInOutData);
};
